import Vue from 'vue';
import Vuex from 'vuex';
import firebase from 'firebase';
import router from './router';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: null,
        isAuthenticated: false
    },
    mutations: {
        setUser(state, payload) {
            state.user = payload;
        },
        setIsAuthenticated(state, payload) {
            state.isAuthenticated = payload;
        }
    },
    actions: {
        userSignUp({ commit }, { name, email, password }) {
            firebase
                .auth()
                .createUserWithEmailAndPassword(email, password)
                .then( user => {
                    firebase.auth().currentUser.updateProfile({ displayName: name }) 
                    commit('setUser', user);
                    commit('setIsAuthenticated', true);
                    router.push('/');
                })
                .catch((err) => {
                    commit('setUser', null);
                    commit('setIsAuthenticated', false);
                    //router.push('/');
                    alert(err.message)
                });
        },        
        userLogin({ commit }, { email, password }) {
            firebase
                .auth()
                .signInWithEmailAndPassword(email, password)
                .then( user => {
                    commit('setUser', user);
                    commit('setIsAuthenticated', true);
                    router.push('/');
                })
                .catch((err) => {
                    commit('setUser', null);
                    commit('setIsAuthenticated', false);
                    //router.push('/');
                    alert(err.message)
                });
        },
        userLogOut({ commit }) {
            firebase
                .auth()
                .signOut()
                .then(() => {
                    commit('setUser', null);
                    commit('setIsAuthenticated', false);
                    if(router.currentRoute.name !== 'login') router.push('/login');
                })
                .catch(() => {
                    commit('setUser', null);
                    commit('setIsAuthenticated', false);
                    if(router.currentRoute.name !== 'login') router.push('/login');
                });
        }

    },
    getters: {
        isAuthenticated(state) {
            return state.user !== null && state.user !== undefined;
        }
    }
});